import React from 'react';
import {
  createStyles,
  makeStyles,
  Typography,
  TypographyProps,
} from '@material-ui/core';
import * as Weights from '../../theme/weights';

export const typography9RegularStyle = {
  fontWeight: Weights.regular,
  fontSize: '9px',
  lineHeight: '20px',
};

export const typography9MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '9px',
  lineHeight: '20px',
};

export const typography12RegularStyle = {
  fontWeight: Weights.regular,
  fontSize: '12px',
  lineHeight: '18px',
};

export const typography12MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '12px',
  lineHeight: '19px',
};

export const typography13MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '13px',
  lineHeight: '24px',
};

export const typography13RegularStyle = {
  fontWeight: Weights.regular,
  fontSize: '13px',
  lineHeight: '20px',
};

export const typography15RegularStyle = {
  fontWeight: Weights.regular,
  fontSize: '15px',
  lineHeight: '24px',
};

export const typography15MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '15px',
  lineHeight: '24px',
};

export const typography18MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '18px',
  lineHeight: '24px',
};

export const typography24MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '24px',
  lineHeight: '30px',
};

export const typography10MediumStyle = {
  fontWeight: Weights.medium,
  fontSize: '10px',
  lineHeight: '20px',
};

export const typography10RegularStyle = {
  fontWeight: Weights.regular,
  fontSize: '10px',
  lineHeight: '20px',
};

export const typography65RegularStyle = {
  fontWeight: Weights.regular,
  fontSize: '65px',
  lineHeight: '150px',
};

export const typography15SemiBoldStyle = {
  fontWeight: Weights.semiBold,
  fontSize: '15px',
  lineHeight: '24px',
};
export const typography24SemiBoldStyle = {
  fontWeight: Weights.semiBold,
  fontSize: '24px',
  lineHeight: '30px',
};
export const typography24BoldStyle = {
  fontWeight: Weights.bold,
  fontSize: '24px',
  lineHeight: '29px',
};

export const typography36BoldStyle = {
  fontWeight: Weights.bold,
  fontSize: '36px',
  lineHeight: '44px',
};

const useStyles = makeStyles(() =>
  createStyles({
    '9Regular': typography9RegularStyle,
    '9Medium': typography9MediumStyle,
    '10Medium': typography10MediumStyle,
    '10Regular': typography10RegularStyle,
    '12Regular': typography12RegularStyle,
    '12Medium': typography12MediumStyle,
    '13Medium': typography13MediumStyle,
    '13Regular': typography13RegularStyle,
    '15Regular': typography15RegularStyle,
    '15Medium': typography15MediumStyle,
    '18Medium': typography18MediumStyle,
    '24Medium': typography24MediumStyle,
    '65Regular': typography65RegularStyle,
    '15semiBold': typography15SemiBoldStyle,
    '36Bold': typography36BoldStyle,
    '24semiBold': typography24SemiBoldStyle,
  }),
);
export type FontType =
  | '9Regular'
  | '9Medium'
  | '10Medium'
  | '10Regular'
  | '12Regular'
  | '12Medium'
  | '13Medium'
  | '13Regular'
  | '15Regular'
  | '15Medium'
  | '18Medium'
  | '24Medium'
  | '12Regular'
  | '36Bold'
  | '65Regular'
  | '15semiBold'
  | '24semiBold';

export interface BaseTypographyProps {
  fontType?: FontType;
}

const BaseTypography: React.FC<BaseTypographyProps & TypographyProps> = ({
  children,
  fontType = '13Regular',
  className,
  component = 'div',
  ...props
}) => {
  const classes = useStyles();
  const classNames = [classes[fontType]];
  if (className) {
    classNames.push(className);
  }

  return (
    <Typography
      component={component}
      variant="inherit"
      className={classNames.join(' ')}
      {...props}
    >
      {children}
    </Typography>
  );
};

const MemoBaseTypography = React.memo(BaseTypography);

export default MemoBaseTypography;
